import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useGetUserRole } from "Services/Hooks";
// State
import DashboardJustReleased from "../../Components/DashboardJustReleased";
import { getOrganisation } from "@intelligentlilli/api-layer";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "State/hooks";

const DashboardHeader = () => {
  const user = useAppSelector((state) => state.user.authData);
  const server = useAppSelector((state) => state.session.server);
  const [organisation, setOrganisation] = useState();
  const navigate = useNavigate();
  const { userIsManagerOrAdmin } = useGetUserRole();

  const videoSource =
    "https://www.youtube.com/embed/FEF0PfpmDT8?si=lL2BgHf_kaCFXPQL";
  const showJustReleased = true;

  useEffect(() => {
    if (user?.organisationId) {
      getOrganisation(server, user.organisationId, "web")
        .then((res) => res.ok && setOrganisation(res.data))
        .catch((err) => {
          console.log(err);
        });
    }
  }, [user?.organisationId, navigate, server]);

  return (
    <div className={styles.dashboard_header_container}>
      <div>
        <div className={styles.page_title}>Dashboard</div>
        <div className={styles.user_info} data-private>
          {user?.forenames} {user?.surname} | {organisation?.name ?? ""}
        </div>
      </div>
      {showJustReleased && userIsManagerOrAdmin && (
        <div className={styles.component_just_released}>
          <DashboardJustReleased
            releaseTitle={"Just Released: Install Performance"}
            releaseSubheading={
              "Get a quick snapshot and a historical look at how installs are going."
            }
            videoSourceURL={videoSource}
            videoDescription={""}
            showVideoButton={true}
          />
        </div>
      )}
    </div>
  );
};

export default DashboardHeader;
